
import ProjectLinkItem from "./ProjectLinkItem"
import styles from './ProjectLinkGroup.module.css'
import { useLanguage } from '../contexts/LanguageContext'
import {getData} from './Model'

function ProjectLinkGroup({repos, language}){
    const ui = getData('ui', language)
    
    return (
        <div className={styles.ProjectLinkGroup}>
            <h4>{language === 'eng' ? 'Repositories' : 'Репозитории'}</h4>
            {repos.map((repo, index) => (
                <ProjectLinkItem 
                    key={index} 
                    {...repo} 
                    language={language}
                />
            ))}
        </div>
    )
}

export default ProjectLinkGroup